import { render, staticRenderFns } from "./pcIndex.vue?vue&type=template&id=5bdd5103&"
import script from "./pcIndex.vue?vue&type=script&lang=js&"
export * from "./pcIndex.vue?vue&type=script&lang=js&"
import style0 from "./pcIndex.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./pcIndex.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports